export default class RequestPasswordResetDto
{
    constructor(public username: string) {
    }
}
